window.kpShowSuccessToast = function(message = 'Added to Cart successfully!') {
  let toast = document.getElementById('kp-global-toast');
  if (toast) toast.remove();

  toast = document.createElement('div');
  toast.id = 'kp-global-toast';
  toast.innerHTML = `
    <div style="display:flex; align-items:center; gap:12px;">
      <div style="background:#8BC34A; width:24px; height:24px; border-radius:50%; display:flex; align-items:center; justify-content:center;">
        <svg viewBox="0 0 24 24" style="width:14px; height:14px; fill:#fff;"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>
      </div>
      <span style="font-weight:700; font-size:15px; color:#3b821e;">${message}</span>
    </div>
  `;
  
  Object.assign(toast.style, {
    position: 'fixed',
    top: '20px',
    right: '20px',
    background: '#f1f8e9',
    border: '1px solid #c5e1a5',
    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
    padding: '16px 20px',
    borderRadius: '12px',
    zIndex: '99999999',
    transform: 'translateY(-100px)',
    opacity: '0',
    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
  });

  document.body.appendChild(toast);

  // Force synchronous reflow to ensure the transition fires correctly
  toast.getBoundingClientRect(); 

  toast.style.transform = 'translateY(0)';
  toast.style.opacity = '1';

  setTimeout(() => {
    toast.style.transform = 'translateY(-100px)';
    toast.style.opacity = '0';
    setTimeout(() => toast.remove(), 400);
  }, 3000);
}

if (!customElements.get('kp-cart-updater')) {
  customElements.define('kp-cart-updater', class KpCartUpdater extends HTMLElement {
    constructor() {
      super();
    }

    getSectionsToRender() {
      return [
        {
          id: 'kp-free-shipping-bar',
          selector: '.shopify-section'
        },
        {
          id: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }

    connectedCallback() {
      if (window.PUB_SUB_EVENTS && window.subscribe) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }
    }

    onCartUpdate() {
      fetch(`${window.routes?.cart_url || '/cart'}?section_id=kp-free-shipping-bar&v=${Date.now()}`)
        .then(response => response.text())
        .then(html => {
          const outerEls = document.querySelectorAll('.kp-free-shipping-outer');
          if (outerEls.length > 0) {
            const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('.kp-free-shipping-outer');
            if (parsed) {
              outerEls.forEach(el => el.innerHTML = parsed.innerHTML);
            }
          }
        })
        .catch(e => console.error(e));
    }

    renderContents(parsedState) {
      if (parsedState.errors) return;

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = document.getElementById(section.id) || document.getElementById(`shopify-section-${section.id}`);
        if(sectionElement && parsedState.sections[section.id]) {
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector || '.shopify-section');
        }
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : html;
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  });
}

